import { render } from "./ChatHistoryItem.vue?vue&type=template&id=8f22b822&scoped=true"
import script from "./ChatHistoryItem.vue?vue&type=script&lang=js"
export * from "./ChatHistoryItem.vue?vue&type=script&lang=js"

import "./ChatHistoryItem.vue?vue&type=style&index=0&id=8f22b822&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f22b822"]])

export default __exports__